import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getListByType, schemeToSubProject } from '@/api/payroll';
import attendanceDetail from './components/detail.vue';
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: {
    attendanceDetail: attendanceDetail
  },
  data: function data() {
    return {
      byTypeList: []
    };
  },
  computed: {
    disEid: function disEid() {
      // 计算失败、计算成功无法编辑
      return ['3', '4'].includes(this.activeData.info.calculate_state);
    }
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      // 获取记薪方案列表
      getListByType({
        type: this.activeData.info.settlement_type || 1
      }).then(function (res) {
        if (res && res.code === 1) _this.byTypeList = res.data;
      });
    },
    handleRadio: function handleRadio(item) {
      // 选中记薪方案
      if (!this.disEid) this.activeData.payroll_sub_project_scheme_id = item.payroll_sub_project_scheme_id;
    },
    handleClick: function handleClick(item) {
      //  查看详情
      this.$refs.attendance.init(item);
    },
    saveData: function saveData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var query;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 同步计薪方案 到 子项目
              query = {
                sub_project_id: _this2.activeData.sub_project_id || _this2.$s.get('sub_project_id'),
                payroll_sub_project_scheme_id: _this2.activeData.payroll_sub_project_scheme_id
              };
              _context.next = 3;
              return schemeToSubProject(query);
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleAdd: function handleAdd() {
      // 添加记薪方案
      this.$emit('handleAdd');
    }
  }
};